import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMealTypes,
  createMealType,
  updateMealType,
  resetMealTypeState,
} from '../store/mealTypeSlice';

const MealTypeScreen = () => {
  const dispatch = useDispatch();
  const { mealTypes, success, isLoading, error } = useSelector((state) => state.mealType);

  const [form, setForm] = useState({ type: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    dispatch(fetchMealTypes());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      alert(isEditing ? 'Meal Type updated!' : 'Meal Type created!');
      setForm({ type: '' });
      setIsEditing(false);
      setSelectedId(null);
      dispatch(resetMealTypeState());
    }
  }, [success, dispatch, isEditing]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.type.trim()) return;

    if (isEditing && selectedId) {
      dispatch(updateMealType({ id: selectedId, formData: form }));
    } else {
      dispatch(createMealType(form));
    }
  };

  const handleEdit = (mealType) => {
    setForm({ type: mealType.type });
    setIsEditing(true);
    setSelectedId(mealType.id);
  };

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-6">
      <h2 className="text-2xl font-bold">{isEditing ? 'Edit Meal Type' : 'New Meal Type'}</h2>

      {error && <p className="text-red-500">{error?.message || 'Something went wrong'}</p>}

      <form onSubmit={handleSubmit} className="flex gap-4">
        <input
          type="text"
          name="type"
          placeholder="Meal Type"
          value={form.type}
          onChange={(e) => setForm({ type: e.target.value })}
          className="w-full px-4 py-2 border rounded"
          required
        />
        <button
          type="submit"
          disabled={isLoading}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {isLoading ? 'Saving...' : isEditing ? 'Update' : 'Create'}
        </button>
      </form>

      <div className="bg-white shadow rounded p-4">
        <h3 className="text-lg font-semibold mb-2">Meal Types</h3>
        <ul className="divide-y">
          {mealTypes.map((mealType) => (
            <li
              key={mealType.id}
              onClick={() => handleEdit(mealType)}
              className="py-2 cursor-pointer hover:bg-gray-50"
            >
              {mealType.type}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MealTypeScreen;
